export const env = "new"

const URLS = {
    dev: "https://kimchiapi.diginestsolutions.in/public/api/",
    demo: 'https://digisvapi.diginestsolutions.in/public/api/',
    new: 'https://api.japanesekoreanmart.com/api/'
}

const IMAGE = {
    dev: 'https://kimchiapi.diginestsolutions.in',
    demo: 'https://digisvapi.diginestsolutions.in/public',
    new: 'https://api.japanesekoreanmart.com'
}
export const BASE_URL = URLS[env];
export const IMG_URL = IMAGE[env]